export const toolErrorToolMessage = (toolMessage: any, results: any) => {
    const errorMessage = results.errorMessage ?? 'Tool call failed.';
    const content = [{
        type: 'text',
        text: errorMessage
    }];

    return {...toolMessage, content, truncatedContent: content};
};
